import DepositCoolingOffSettings from "@/models/Products/ProductSettings/DefaultSettings/CoolingOff/CoolingOffSettings";

export default class UpdateDepositCoolingOffSettings extends DepositCoolingOffSettings {
    updatedAt: Date;

    public constructor(settings: DepositCoolingOffSettings, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.enabled = settings.enabled;
            this.coolingOffPeriodType = settings.coolingOffPeriodType;
            this.coolingOffPeriodValue = +settings.coolingOffPeriodValue;
        }
    }
}